import type { Environment } from '@hangar/shared';
import { DeleteEnvVarDialog } from './DeleteEnvVarDialog';
import { EnvVarSheet } from './EnvVarSheet';
import { ImportSheet } from './ImportSheet';
import { NewVersionSheet } from './NewVersionSheet';
import { RevealDialog } from './RevealDialog';
import { VersionsSheet } from './VersionsSheet';
import type { EnvPageApi } from './useEnvPage';
import type { EnvDialogsApi } from './useEnvDialogs';

/** `onOpenChange` handlers only ever close: opening is done by the buttons of the page. */
const closeOnly = (close: () => void) => (open: boolean) => (open ? undefined : close());

/** Every sheet and dialog of the page. */
export function EnvPageDialogs({ page, dialogs, projectId, environments }: { page: EnvPageApi; dialogs: EnvDialogsApi; projectId: string; environments: Environment[] }) {
  const d = dialogs;
  const apps = page.apps.data;
  return (
    <>
      <EnvVarSheet open={d.creating || Boolean(d.editing)} onOpenChange={closeOnly(() => (d.setCreating(false), d.setEditing(undefined)))} editing={d.editing} projectId={projectId} scope={page.scope} apps={apps} environments={environments} />
      <NewVersionSheet envVar={d.versionFor} onOpenChange={closeOnly(() => d.setVersionFor(null))} />
      <RevealDialog envVar={d.revealFor} onOpenChange={closeOnly(() => d.setRevealFor(null))} />
      <VersionsSheet envVar={d.versionsFor} onOpenChange={closeOnly(() => d.setVersionsFor(null))} />
      <ImportSheet open={d.importing} onOpenChange={d.setImporting} projectId={projectId} scope={page.scope} apps={apps} />
      <DeleteEnvVarDialog deleting={d.deleting} onClose={() => d.setDeleting(null)} />
    </>
  );
}
